import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import { CSVLink } from 'react-csv'
import FilterPill from './FilterPill'
import { FILTER_OPTIONS } from '../mock/ledger'

export default function TransactionFilterBar({
  year, onChangeYear, account, onChangeAccount, type, onChangeType, status, onChangeStatus, csvData
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-3">
        <FilterPill label={FILTER_OPTIONS.years[0]} active={year} options={FILTER_OPTIONS.years} onSelect={onChangeYear} />
        <FilterPill label={FILTER_OPTIONS.accounts[0]} active={account} options={FILTER_OPTIONS.accounts} onSelect={onChangeAccount} />
        <FilterPill label={FILTER_OPTIONS.types[0]} active={type} options={FILTER_OPTIONS.types} onSelect={onChangeType} />
        <FilterPill label={FILTER_OPTIONS.statuses[0]} active={status} options={FILTER_OPTIONS.statuses} onSelect={onChangeStatus} />
      </div>

      <CSVLink
        data={csvData}
        filename="transactions.csv"
        className="flex items-center gap-2 bg-white border border-border-lines rounded-full h-9 px-4 text-sm font-semibold text-dark-blue whitespace-nowrap"
      >
        <UIcons.UilExport size={16} /> Export Statement
      </CSVLink>
    </div>
  )
}
